import {
  getRegionId,
  getSecurityId,
  getUserSelectedLanguage,
} from 'reducers/users';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import API from 'services/api';
import { setLoading, showSnackbar } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';

import { actions as emergencyActions } from 'containers/Pages/Tasks/Emergencies/Modules/dataGridTable';
import {
  emergencyPageActions,
  emergencyDataGridAction,
  emergencyFilterActions,
} from 'containers/Pages/Tasks/Emergencies';
import { getTimezone } from 'reducers/utils';
import { t } from 'i18next';
//get the list stuff
export function* fetchEmergencyListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const timezone = yield select(getTimezone);
    const regionId = yield select(getRegionId);
    const securityCompanyId = yield select(getSecurityId);
    const { data } = yield call(API.fetchDistresses, {
      regionId,
      securityCompanyId,
      ...filters,
      from,
      timezone,
    });
    if (data.data != null) {
      const totalEntries = get(data, 'meta.total');
      yield put(
        emergencyActions.setGridList({ list: data.data, totalEntries }),
      );
    }
    yield put(emergencyFilterActions.setFilterKey(false));
    yield put(emergencyDataGridAction.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchEmergencyDetailSaga({ payload }) {
  try {
    yield put(setLoading(false));
    const { id } = payload;
    const { data } = yield call(API.fetchDistressDetails, id);
    if (data.data != null) {
      yield put(emergencyActions.setGridRowDetails({ details: data.data }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* resolveEmergencySaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id, resolvedAborted } = payload;
    //update api
    const { data } = yield call(API.abortDistress, { id, resolvedAborted });
    //on response reset the details
    if (data.data != null) {
      const abortResolved = resolvedAborted ? t('aborted') : t('resolved');
      yield put(
        showSnackbar({
          typeOfSnackbar: 'success',
          message: `${t('Emergency')} ${abortResolved}`,
        }),
      );
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* assignResponderSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id, responder } = payload;
    //update api
    const { data } = yield call(API.assignResponder, { id, responder });
    //on response reset the details
    if (data.data != null) {
      yield call(fetchEmergencyDetailSaga, { payload: { id } });
    }
    yield put(
      showSnackbar({
        typeOfSnackbar: 'success',
        message: 'Message sent',
      }),
    );
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* printEmergencyListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters } = payload;
    const timezone = yield select(getTimezone);
    const regionId = yield select(getRegionId);
    const securityCompanyId = yield select(getSecurityId);
    const language = yield select(getUserSelectedLanguage);
    const { data } = yield call(API.fetchDistressListPdf, {
      regionId,
      securityCompanyId,
      timezone,
      language: language.toUpperCase(),
      ...filters,
    });
    if (data.data) {
      const { url } = data.data;
      window.open(url, '_blank');
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* printEmergencyDetailsSaga({ payload }) {
  try {
    const { id } = payload;
    yield put(setLoading(true));
    const timezone = yield select(getTimezone);
    const language = yield select(getUserSelectedLanguage);
    const { data } = yield call(API.fetchDistressDetailsPdf, {
      id,
      timezone,
      language: language.toUpperCase(),
    });
    if (data.data) {
      const { url } = data.data;
      window.open(url, '_blank');
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* emergencySagas() {
  yield takeLatest(emergencyActions.fetchGridList, fetchEmergencyListSaga);
  yield takeLatest(
    emergencyActions.fetchGridRowDetails,
    fetchEmergencyDetailSaga,
  );
  yield takeLatest(emergencyPageActions.assignResponder, assignResponderSaga);
  yield takeLatest(emergencyPageActions.resolveEmergency, resolveEmergencySaga);
  yield takeLatest(
    emergencyPageActions.printEmergencyDetails,
    printEmergencyDetailsSaga,
  );
  yield takeLatest(
    emergencyPageActions.printEmergencyList,
    printEmergencyListSaga,
  );
}
